'use client';

import { Grid, VStack } from '@terra/ui-styled-system';
import { supportsNotificationCenter } from '../../hooks/dashboard/useTargetNotificationCenter';
import { useTargetType } from '../../store/projectStore';
import type { NeedsAttentionItem } from './needs-attention-items';
import { NeedsAttentionCard } from './NeedsAttentionCard';
import { RecentItemsCard } from './RecentItemsCard';
import { TargetHealthCard, type LocalHealthIssue } from './TargetHealthCard';

type HomeWorkGridProps = {
  applicationId: string;
  attentionItems: NeedsAttentionItem[];
  isAttentionLoading: boolean;
  localHealthIssues?: LocalHealthIssue[];
  healthyDetail?: string;
};

export function HomeWorkGrid({
  applicationId,
  attentionItems,
  isAttentionLoading,
  localHealthIssues,
  healthyDetail,
}: HomeWorkGridProps) {
  const targetType = useTargetType();
  const hasHealthChecks =
    supportsNotificationCenter(targetType) || localHealthIssues !== undefined;

  return (
    <Grid w="full" columns={{ base: 1, lg: 2 }} gap={4} alignItems="stretch">
      <NeedsAttentionCard
        applicationId={applicationId}
        items={attentionItems}
        isLoading={isAttentionLoading}
      />
      <VStack gap={4} alignItems="stretch" h="full">
        {hasHealthChecks ? (
          <TargetHealthCard
            applicationId={applicationId}
            localIssues={localHealthIssues}
            healthyDetail={healthyDetail}
          />
        ) : null}
        <RecentItemsCard applicationId={applicationId} />
      </VStack>
    </Grid>
  );
}
